import { render, staticRenderFns } from "./TotalRevenuePage.vue?vue&type=template&id=2953e939&scoped=true&"
import script from "./TotalRevenuePage.vue?vue&type=script&lang=js&"
export * from "./TotalRevenuePage.vue?vue&type=script&lang=js&"
import style0 from "./TotalRevenuePage.vue?vue&type=style&index=0&id=2953e939&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2953e939",
  null
  
)

export default component.exports